import { createFileRoute } from "@tanstack/react-router";

import { parseWalletSearch } from "@/features/money";
import { WalletPage } from "@/features/money/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/money/wallets/$providerId")({
  validateSearch: strictSearch(parseWalletSearch),
  component: Wallet,
});

function Wallet() {
  const { providerId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <WalletPage
      key={providerId}
      owner={{ by: "provider", id: providerId }}
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
